module.exports = __webpack_public_path__ + "img/jd2_jixw_ic1.86cc6db2.png";